<script>
    export default {
        props: {
            uploadUrl: String,
            uploadDisk: String,
            mediaImportUrl: String,
            filter: Object,
        },
        data() {
            return {
                token: Scoop.csrfToken,
                maxFilesize: Scoop.uploadMaxFilesize,
            }
        },
        mounted() {
            this.initDropzone();
        },
        methods: {
            initDropzone() {
                Dropzone.options.imageUpload = {
                    vm: this,
                    maxFilesize: this.maxFilesize,
                    timeout: 1800000,
                    init: function () {
                        var uploadFiles = 0;

                        this.on("addedfile", function () {
                            this.options.vm.$emit('detected');

                            uploadFiles++;
                        });

                        this.on("complete", function () {
                            uploadFiles--;

                            if (uploadFiles === 0) {
                                window.location.href = this.options.vm.mediaImportUrl;
                            }
                        });
                    }
                };
            }
        },
    }
</script>

<template>
    <div class="ibox float-e-margins media-upload">
        <div class="ibox-title">
            <h5 v-text="__('scoop-os.common.upload')"></h5>
        </div>
        <div class="ibox-content h-300">
            <form method="post" :action="uploadUrl"
                  accept-charset="utf-8" enctype="multipart/form-data"
                  class="dropzone" id="image-upload">
                <input type="hidden" name="uploadDisk" :value="uploadDisk"/>
                <input type="hidden" name="frmMediaIndex" id="frmMediaIndex"
                       :value="filter.index"/>
                <input type="hidden" name="frmMediaDirectory" id="frmMediaDirectory"
                       :value="filter.directory ? filter.directory : ''"/>
                <input type="hidden" name="_token" :value="token"/>
                <div class="dz-message" data-dz-message>
                    <div class="text text-center">
                        <i class="fa fa-cloud-upload fa-5x" aria-hidden="true"></i>
                        <h3 v-text="__('scoop-os.common.drop_to_upload')"></h3>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<style lang="scss">
    #image-upload {
        border: dashed 1px #ccc;
        min-height: 263px;
        line-height: 135px;

        .dz-message {
            color: #b5b5b5;
        }
    }
</style>